import { InteractiveTag as InteractiveTagInternal } from './InteractiveTag';
import { InteractiveTagIcon } from './InteractiveTagIcon';
import { InteractiveTagContent } from './InteractiveTagContent';
import { InteractiveTagWrapper } from './InteractiveTagWrapper';

export { InteractiveTags } from './InteractiveTags';

/** @deprecated Use ActionChip or FilterChipList instead */
export const InteractiveTag = Object.assign(InteractiveTagInternal, {
  /** @deprecated Use ActionChip or FilterChipList instead */
  Icon: InteractiveTagIcon,
  /** @deprecated Use ActionChip or FilterChipList instead */
  Content: InteractiveTagContent,
  /** @deprecated Use ActionChip or FilterChipList instead */
  Wrapper: InteractiveTagWrapper,
});
